import { Box, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import DescriptionList from 'components/DescriptionList'
import AdminJobDetailContext from 'pages/AdminJobDetail/context'
import React from 'react'
import { adminBillingAccountDetailURL, adminPracticeDetailURL } from 'routes/urls'
import { HYGIENIST_SUPPORT_LABEL_MAPPING } from 'types/constants'
import PracticeContactInfo from 'components/PracticeContactInfo'

const AdminJobProfile: React.FC = () => {
  const { job } = React.useContext(AdminJobDetailContext)
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <DescriptionList labelWidth='20%' valueWidth='80%' rowGap={1} data={[{
        label: 'ID',
        value: job.job_id.toString()
      }, {
        label: 'Practice Name',
        value: (
          <Link component={RouterLink} to={adminPracticeDetailURL(job.practice_id)}>
            { job.practice_label }
          </Link>
        )
      }, {
        label: 'Billing Account',
        value: (
          <Link component={RouterLink} to={adminBillingAccountDetailURL(job.billing_account_id)}>
            Billing Account ID: {job.billing_account_id}
          </Link>
        )
      }, {
        label: 'Address',
        value: job.address,
        sx: { whiteSpace: 'pre-line' }
      }, {
        label: 'Practice Phone Numbers',
        value: <PracticeContactInfo inquiries={job.phone_for_inquiries} notifications={job.phone_for_notifications} />
      }, {
        label: 'Practice Emails',
        value: <PracticeContactInfo inquiries={job.email_for_inquiries} notifications={job.email_for_notifications} />
      }, {
        label: 'Manager',
        value: job.first_member_label,
      }, {
        label: 'Date',
        value: `${job.date_label(job.practice_tz)} (Starting in ${job.countdown_label()})`
      }, {
        label: 'Time',
        value: job.time_label(job.practice_tz)
      }, {
        label: 'Published At',
        value: job.published_at_label(job.practice_tz) ?? 'Not Published'
      }, {
        label: 'Cancel At',
        value: job.cancel_at_label(job.practice_tz) ?? 'Not Cancelled'
      }, {
        label: 'Headcount',
        value: `${job.headcount} (total), ${job.filled_employment_count} (filled), ${job.outstanding} (outstanding)`
      }, {
        label: 'Lunch Break',
        value: job.lunch_break_label
      }, {
        label: 'Duration',
        value: job.duration_label
      }, {
        label: 'Nurse Support (For Hygienist Bookings Only)',
        value: HYGIENIST_SUPPORT_LABEL_MAPPING[job.hygienist_support]
      }, {
        label: 'Description',
        value: job.description,
        sx: { whiteSpace: 'pre-line' }
      }, {
        label: 'Parking',
        value: job.parking_label
      }, {
        label: 'Late Cancellation Policy',
        value: job.practice_late_cancellation_policy,
      }, {
        label: 'Document Sharing Required',
        value: job.document_sharing_required ? 'Yes': 'No'
      }, {
        label: 'Extended Compliance Required',
        value: job.extended_compliance_required ? 'Yes': 'No'
      }, {
        label: 'Scotland Compliance Required',
        value: job.scotland_compliance_required ? 'Yes': 'No'
      }, {
        label: 'Job Role',
        value: job.job_role
      }, {
        label: 'Specialist Requirements',
        value: job.specialist_requirements.length > 0 ? job.specialist_requirements.join(', ') : 'None'
      }, {
        label: 'Nurse Preference',
        value: job.nurse_preference_label
      }, {
        label: 'Job opened to preferred nurses?',
        value: job.is_open_to_tier_label('preferred')
      }, {
        label: 'Job opened to good tier?',
        value: job.is_open_to_tier_label('good')
      }, {
        label: 'Job opened to new tier?',
        value: job.is_open_to_tier_label('new')
      }, {
        label: 'Job opened to bad tier?',
        value: job.is_open_to_tier_label('bad')
      }, {
        label: 'Bonus Job to Preferred Nurses',
        value: job.is_bonus_to_tier_label('preferred')
      }, {
        label: 'Bonus Job to Good Tier',
        value: job.is_bonus_to_tier_label('good')
      }, {
        label: 'Bonus Job to New Tier',
        value: job.is_bonus_to_tier_label('new')
      }, {
        label: 'Bonus Job to Bad Tier',
        value: job.is_bonus_to_tier_label('bad')
      }]} />
    </Box>
  )
}

export default AdminJobProfile